import request from "@/request";

/**
 * 获取素材
 * @returns {AxiosPromise}
 */
export function getMaterial(data) {
  const url = "/api/v1/editor/get_material";
  return request({ url, method: "POST", data: data });
}

/**
 * 获取用户收藏素材
 * @returns {AxiosPromise}
 */
export function materialFavourApi(data) {
  const url = "/api/v1/editor/material_favour";
  return request({ url, method: "POST", data: data });
}

/**
 * 获取用户收藏素材
 * @returns {AxiosPromise}
 */
export function pointCount(data) {
  const url = "/api/v1/editor/material_point_count";
  return request({ url, method: "POST", data: data });
}

/**
 * 生成/更新草稿
 * @returns {AxiosPromise}
 */
export function materialDraft(data) {
  const url = "/api/v1/editor/material_draft";
  return request({ url, method: "POST", data: data });
}

/**
 * 用户草稿
 * @returns {AxiosPromise}
 */
export function getDraftList(data) {
  const url = "/api/v1/editor/get_draft_list";
  return request({ url, method: "POST", data: data });
}

/**
 * 删除草稿
 * @returns {AxiosPromise}
 */
export function deleteDraft(data) {
  const url = "/api/v1/editor/delete_draft";
  return request({ url, method: "POST", data: data });
}

/**
 * 素材列表
 * @returns {AxiosPromise}
 */
export function materialList(data) {
  const url = "/api/v1/editor/material_list";
  return request({ url, method: "POST", data: data });
}

/**
 * 修改素材
 * @returns {AxiosPromise}
 */
export function materialModify(data) {
  const url = "/api/v1/editor/material_modify";
  return request({ url, method: "POST", data: data });
}

/**
 * 素材类型列表
 * @returns {AxiosPromise}
 */
export function materialTypeList() {
  const url = "/api/v1/editor/material_type_list";
  return request({ url, method: "GET" });
}

/**
 * 手机预览
 * @returns {AxiosPromise}
 */
export function mobilePreview(data) {
  const url = "/api/v1/editor/mobile_preview";
  return request({ url, method: "POST", data: data });
}
